// component bind EpreuveBoard.js

import React, { Component } from "react";
import { Link } from "react-router-dom";
import EventsAddToBasket from "../Components/EventsAddToBasket";

export class EpreuvesList extends Component {
  render() {
    const { epreuves } = this.props;
    console.log("listEpreuves", epreuves);
    return (
      <div className="w-100">
        <ul>
          <div className="">{epreuves.map(this.renderEpreuve.bind(this))}</div>
        </ul>
      </div>
    );
  }

  renderEpreuve(epreuve) {
    return (
      <div className="row">
        <div className="col-md-11">
          <Link
            reloaddocument={true}
            to={`/epreuve/${epreuve.id}?${epreuve.name_event}`}
            className="text-dark text-decoration-none itemTri"
            key={epreuve.name_event + "-" + epreuve.id}
          >
            <li
              className="row border mb-2 rounded hoverCardColor"
              key={epreuve.id + epreuve.name_event}
              style={{ height: "auto", width: "100%" }}
            >
              <div className="col-lg-2 col-12 media-content">
                {epreuve.date.slice(0, 10)}
              </div>
              <div className="col-lg-5 col-12 media-content font-weight-bold">
                {epreuve.name_event}
              </div>
              <div className="col-lg-2 col-12 media-content">
                {epreuve.city} ({epreuve.department})
              </div>
              <div className="col-lg-3 col-12 media-content p-0 border border-warning">
                {epreuve.races.map((item) => (
                  <span
                    className="my-auto py-auto px-2 w-100 h-100"
                    key={item.type_triathlon}
                  >
                    {item.type_triathlon}
                  </span>
                ))}
              </div>
            </li>
          </Link>
        </div>
        <div className="col-md-1 col-12 media-content">
          <EventsAddToBasket epreuve={epreuve} />
        </div>
      </div>
    );
  }
}
